"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapFeeAbi = void 0;
exports.swapFeeAbi = [
    {
        inputs: [],
        name: 'swapFee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=swapFeeAbi.js.map